<template>
    <div class="flex flex-col gap-2 p-3 rounded-lg border border-theme-border">
        <div class="flex items-start gap-2">
            <div class="flex-1">
                <p class="font-bold text-theme-base text-sm">
                    {{ merchant.name }}
                </p>
                <span
                    class="text-2.5 uppercase tracking-wider text-theme-primary"
                >
                    {{ merchant.merchantType }}
                    {{
                        merchant.identificationNumber
                            ? ` | ${merchant.identificationType}: ${merchant.identificationNumber}`
                            : ""
                    }}
                </span>
            </div>
        </div>

        <div class="space-y-1 text-xs">
            <div class="flex flex-col">
                <span class="text-theme-muted font-medium">Dirección:</span>
                <p class="text-theme-base">
                    {{ merchant.address }}
                </p>
                <p
                    v-if="merchant.addressComplement"
                    class="italic text-theme-base"
                >
                    {{ merchant.addressComplement }}
                </p>
            </div>

            <div class="flex justify-between gap-4">
                <div>
                    <span class="text-theme-muted font-medium"> Ciudad: </span>
                    <p class="text-theme-base">
                        {{ merchant.city }}
                    </p>
                </div>
                <div>
                    <span class="text-theme-muted font-medium">Código:</span>
                    <p>
                        {{ merchant.cityCode }}
                    </p>
                </div>
            </div>

            <div class="pt-1 text-2.5 text-theme-muted">
                ID: {{ merchant.id }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MerchantInfoCard",
    props: {
        merchant: {
            type: Object,
            required: true,
            validator: (merchant) => {
                return (
                    merchant &&
                    typeof merchant.name === "string" &&
                    typeof merchant.id !== "undefined"
                );
            }
        }
    }
};
</script>
